import logo from '../logo.png';
import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import './Dashboard.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function Dashboard() {
  const navigate = useNavigate();
  const [showConsommation, setShowConsommation] = useState(true);
  const [file, setFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [data, setData] = useState({ consommations: {}, emissions: {} });

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel')) {
      setFile(file);
      setDragging(false);
      await uploadFile(file);
    } else {
      window.alert('Please upload a valid Excel file.');
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch('http://127.0.0.1:80/WhistleBlower/public/api/upload', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('File upload failed');
      }

      const result = await response.json();
      if (result && result.consommations && result.emissions) {
        setData(result);
        console.log('File uploaded successfully:', result);
      } else {
        throw new Error('Invalid data format');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      window.alert('Error uploading file');
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.xlsx, .xls',
    onDragEnter: () => setDragging(true),
    onDragLeave: () => setDragging(false),
  });

  const removeFile = () => {
    setFile(null);
    setData({ consommations: {}, emissions: {} });
  };

  const consommationData = {
    labels: Object.keys(data.consommations).map(month => new Date(0, month - 1).toLocaleString('default', { month: 'long' })),
    datasets: [{
      label: 'Consommations (kWh)',
      data: Object.values(data.consommations),
      fill: false,
      borderColor: getRandomColor(),
      tension: 0.1,
    }]
  };

  const emissionData = {
    labels: Object.keys(data.emissions).map(month => new Date(0, month - 1).toLocaleString('default', { month: 'long' })),
    datasets: [{
      label: 'Emissions (g CO2)',
      data: Object.values(data.emissions),
      fill: false,
      borderColor: getRandomColor(),
      tension: 0.1,
    }]
  };

  function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <>
      <header className="absolute top-0 left-0 w-full header p-10 flex flex-row items-center justify-between">
        <a href="#" className="flex gap-2 items-center cursor-pointer">
          <img src={logo} className="h-10" alt="logo" />
          <p className="font-black">WHISTLEBLOWER</p>
        </a>
        <h2>Pollution Data Dashboard</h2>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </header>

      <div className="dashboard-container">
        {!file ? (
          <div
            {...getRootProps({ className: 'dropzone' })}
            className={`dropzone-container border-4 border-dashed items-center justify-center flex cursor-pointer ${dragging ? 'border-blue-500 bg-blue-500/10' : 'border-gray-300'}`}
            style={{ width: '50vw', height: '50vh' }}
          >
            <input {...getInputProps()} />
            <p>Drag 'n' drop an Excel file here, or click to select one</p>
          </div>
        ) : (
          <div className="file-info">
            <p>Uploaded file: {file.name}</p>
            <button className="logout-btn" onClick={removeFile}>Remove Excel File</button>
          </div>
        )}

        {file && (
          <>
            <button
              className="toggle-btn"
              onClick={() => setShowConsommation(!showConsommation)}
            >
              {showConsommation ? 'Show Emissions' : 'Show Consommations'}
            </button>

            <div className="chart-container w-10/12 sm:w-[600px] sm:h-[400px] mt-10">
              <Line
                data={showConsommation ? consommationData : emissionData}
                options={{
                  responsive: true,
                  plugins: { legend: { position: 'top' } },
                  maintainAspectRatio: false,
                  scales: {
                    x: {
                      title: {
                        display: true,
                        text: 'Month',
                      },
                    },
                    y: {
                      title: {
                        display: true,
                        text: showConsommation ? 'kWh' : 'g CO2',
                      },
                      beginAtZero: true,
                    },
                  },
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Dashboard;